import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { GoogleAnalyticsConsent } from "./google-analytics-consent";

const root = document.getElementById("analytics-root");
if (root) {
  createRoot(root).render(
    <StrictMode>
      <GoogleAnalyticsConsent
        measurementId={import.meta.env.VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID}
        settingsPlacement={root.dataset.settingsPlacement === "inline" ? "inline" : "floating"}
      />
    </StrictMode>,
  );
}
